import React, { useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Grid, Select, MenuItem, OutlinedInput, InputAdornment, FormHelperText, FormControl
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useFormularioInscricao from './useFormularioInscricao';
import ContainedButton from '../../../shared/buttons/ContainedButton';
import TextButton from '../../../shared/buttons/TextButton';
import Close from '@material-ui/icons/CloseOutlined';
import Save from '@material-ui/icons/SaveOutlined';
import * as Yup from 'yup';
import LabelValue from "../../../shared/labelvalue/LabelValue.js";
import { ValorMonetarioNumberFormatCustom } from "../../../shared/formatters";
import { TIPOS_RENDA } from './rendaMembro';

const useStyles = makeStyles(theme => ({
    dialogContent: {
        paddingTop: theme.spacing(2)
    }
}));

const validationSchema = Yup.object().shape({
    tpRenda: Yup.string().required('Campo obrigatório'),
    vlrRenda: Yup.number().typeError('Deve ser um número').required('Campo obrigatório'),
    ocupacao: Yup.string().required('Campo obrigatório')
});

export default function DialogRenda({ open, onClose, onSave, initialValues, titulo = 'Renda' }) {
    const classes = useStyles();

    const formDialogo = useFormularioInscricao({
        valoresIniciais: { tpRenda: 'P', vlrRenda: '', ocupacao: '' },
        schema: validationSchema,
        aoSubmeter: (values) => {
            onSave(values);
        }
    });

    useEffect(() => {
        if (open) {
            formDialogo.reiniciar({
                values: initialValues || { tpRenda: 'P', vlrRenda: '', ocupacao: '' }
            });
        }
    }, [open, initialValues]);

    return (
        <Dialog scroll="body" open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{initialValues && initialValues.ocupacao ? `Editar ${titulo}` : `Adicionar ${titulo}`}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <LabelValue label="Tipo de Renda *">
                            <FormControl variant="outlined" fullWidth error={formDialogo.tocados.tpRenda && !!formDialogo.erros.tpRenda}>
                                <Select
                                    name="tpRenda"
                                    value={formDialogo.valores.tpRenda}
                                    onChange={formDialogo.aoMudar}
                                    onBlur={formDialogo.aoSair}
                                >
                                    {TIPOS_RENDA.map(tipo => (
                                        <MenuItem key={tipo.valor} value={tipo.valor}>
                                            {tipo.detalhe ? `${tipo.descricao} (${tipo.detalhe})` : tipo.descricao}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {formDialogo.tocados.tpRenda && formDialogo.erros.tpRenda && (
                                    <FormHelperText>{formDialogo.erros.tpRenda}</FormHelperText>
                                )}
                            </FormControl>
                        </LabelValue>
                    </Grid>
                    <Grid item xs={12}>
                        <LabelValue label="Ocupação / Cargo *">
                            <FormControl variant="outlined" fullWidth error={formDialogo.tocados.ocupacao && !!formDialogo.erros.ocupacao}>
                                <OutlinedInput
                                    name="ocupacao"
                                    value={formDialogo.valores.ocupacao}
                                    onChange={formDialogo.aoMudar}
                                    onBlur={formDialogo.aoSair}
                                />
                                {formDialogo.tocados.ocupacao && formDialogo.erros.ocupacao && (
                                    <FormHelperText>{formDialogo.erros.ocupacao}</FormHelperText>
                                )}
                            </FormControl>
                        </LabelValue>
                    </Grid>
                    <Grid item xs={12}>
                        <LabelValue label="Valor Bruto Mensal *">
                            <FormControl variant="outlined" fullWidth error={formDialogo.tocados.vlrRenda && !!formDialogo.erros.vlrRenda}>
                                <OutlinedInput
                                    name="vlrRenda"
                                    value={formDialogo.valores.vlrRenda}
                                    onChange={formDialogo.aoMudar}
                                    onBlur={formDialogo.aoSair}
                                    inputComponent={ValorMonetarioNumberFormatCustom}
                                    startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                                />
                                {formDialogo.tocados.vlrRenda && formDialogo.erros.vlrRenda && (
                                    <FormHelperText>{formDialogo.erros.vlrRenda}</FormHelperText>
                                )}
                            </FormControl>
                        </LabelValue>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose} startIcon={<Close />}>Fechar</TextButton>
                <ContainedButton onClick={formDialogo.submeter} startIcon={<Save />} disabled={formDialogo.enviando}>
                    Salvar
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}
